var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({},'v-btn',{ ..._vm.baseAttrs, ..._vm.$attrs },false),_vm.$listeners),[_vm._t("default",function(){return [_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-content-save")]),_vm._v(" Save ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }